<template>
  <a-spin :spinning="spinning">
    <div class="article-goods" v-if="series">
      <div class="img-wrap">
        <img :src="series.coverPath" class="goods-img" alt="">
      </div>
      <div class="title">
        {{ series.name }}
      </div>
    </div>
    <div class="article-goods-not-found" v-if="!series">
      <a-result status="error" title="系列不存在，请重新添加！">
      </a-result>
    </div>
  </a-spin>
</template>

<script>
import { _queryGoodsSeries } from '@/api/websiteGoodsSeriesApi';

export default {
  name: 'ArticleSeries',
  props: {
    image: String,
    title: String,
    subTitle: String,
    id: String,
  },
  data() {
    return {
      spinning: false,
      series: {},
    };
  },
  watch: {
    async id(val) {
      this.series = await _queryGoodsSeries(val);
    },
  },
  async created() {
    this.spinning = true;
    if (this.id) {
      this.series = await _queryGoodsSeries(this.id);
    }
    this.spinning = false;
  },
};
</script>

<style scoped>

.article-detail-wrap:hover .article-detail-operation {
  display: block;
}

.article-goods {
  padding-bottom: 20px;
}

.img-wrap {
  position: relative;
  width: 100%;
  height: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #036050;
  border-radius: 5px;
}

.title {
  font-weight: 700;
}

.sub-title {
  color: #036050;
}

.goods-img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  display: block;
}

.button {
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: #fff;
  background-color: #036050;
  text-align: center;
  border-radius: 5px;
  margin-top: 20px;
}

.article-goods-not-found {
  height: 532px;
}
</style>
